import Hero from "../components/Hero";
import Marquee from "../components/Marquee";
import ServicesGrid from "../components/ServicesGrid";
import PortfolioGrid from "../components/PortfolioGrid";
import BeforeAfter from "../components/BeforeAfter";
import ReviewsPreview from "../components/ReviewsPreview";
import CtaBanner from "../components/CtaBanner";
import { SectionHeading } from "../components/Reveal";
import { useLang } from "../i18n/LanguageContext";

export default function Home() {
  const { t } = useLang();

  return (
    <div data-testid="home-page">
      <main>
        <Hero />
        <Marquee />

        <section id="servizi-preview" className="bg-white py-24 sm:py-32" data-testid="services-preview-section">
          <div className="mx-auto max-w-7xl px-5 sm:px-8">
            <SectionHeading
              overline={t.home.servicesOverline}
              title={t.home.servicesTitle}
              desc={t.home.servicesDesc}
            />
            <div className="mt-14">
              <ServicesGrid mode="link" />
            </div>
          </div>
        </section>

        <BeforeAfter />

        <section className="bg-surface2/60 py-24 sm:py-32" data-testid="featured-projects-section">
          <div className="mx-auto max-w-7xl px-5 sm:px-8">
            <SectionHeading
              overline={t.home.projectsOverline}
              title={t.home.projectsTitle}
              desc={t.home.projectsDesc}
            />
            <PortfolioGrid preview />
          </div>
        </section>

        <ReviewsPreview />

        <CtaBanner />
      </main>
    </div>
  );
}
